module.exports = __webpack_public_path__ + "img/member_communicate.5e44d0ba.png";